import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IAuthorizationGroupMembershipBulkUpdatePostBody,
  IAuthorizationGroupMembershipListQueryParams,
  IAuthorizationGroupMembershipPostBody,
  IAuthorizationGroupMembershipResponse,
  Resources,
} from '../types'

export class AuthorizationGroupMembershipResource extends GenericResource<
  IAuthorizationGroupMembershipResponse,
  IAuthorizationGroupMembershipListQueryParams,
  never,
  IAuthorizationGroupMembershipPostBody
> {
  constructor(agent: IHttpAgent) {
    super(Resources.AuthorizationGroupMembership, agent)
  }

  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public del = this.buildDel()

  public bulkUpdate = (body: IAuthorizationGroupMembershipBulkUpdatePostBody): Promise<void> =>
    this.agent.post(`${this.resource}/bulkUpdate`, body)
}
